module.exports = __webpack_public_path__ + "static/media/spoonerism-task (13).a6f91e94.mp3";